__webpack_require__.p = "https://bmidxblithuaniaplpreprod.netlify.app/";